
import {MessageBox} from 'element-ui'

function getSearchWord() {
  return localStorage.getItem("searchWord") || '';
}

export const SearchStore = {
  namespaced: true,
  state: {
    historySearch: getSearchWord(),
  },
  mutations: {
    setSearchHistory(state: any, keyword: string) {
      let arr = getSearchWord() ? getSearchWord().split(',') : [];

      if (arr.length === 0) {
        state.historySearch = keyword;
        localStorage.setItem("searchWord", keyword);
      } else {
        // 去除重复的历史搜索
        if (arr.indexOf(keyword) != -1) {
          arr = arr.filter(t => t !== keyword);
        }
        arr.unshift(keyword);
        // 设置历史搜索最多显示多少条
        if (arr.length > 10) {
          arr.pop();
        }
        state.historySearch = arr.join();
        localStorage.setItem("searchWord", state.historySearch);
      }
    },
    delHistry(state: any, index: number) {
      let arr = getSearchWord() ? getSearchWord().split(',') : [];
      arr.splice(index, 1);
      state.historySearch = arr.join();
      localStorage.setItem("searchWord", state.historySearch);
    },
    // 清空历史搜索
    clearSearchHistory(state: any) {
      MessageBox.confirm('确定删除所有的历史记录吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        state.historySearch = "";
        localStorage.removeItem("searchWord");
      });
    },
  },
  getters: {
    historys: (state: any) => {
      return state.historySearch ? state.historySearch.split(',') : [];
    }
  }
};